/// <reference path="./exceljs-browser.d.ts" />
import type { Workbook, Worksheet } from 'exceljs';

// Templates put the fillable rows on this sheet; any other workbook is read from its first sheet.
const TEMPLATE_SHEET_NAME = 'Template';

const pickSheet = (workbook: Workbook): Worksheet | undefined =>
  workbook.getWorksheet(TEMPLATE_SHEET_NAME) ?? workbook.worksheets[0];

// Same rule as the CSV path's `skipEmptyLines: 'greedy'`: rows whose cells are all blank are dropped.
export const sheetToRows = (sheet: Worksheet): string[][] => {
  const width = sheet.getRow(1).cellCount;
  const rows: string[][] = [];
  sheet.eachRow({ includeEmpty: false }, row => {
    const cells: string[] = [];
    for (let col = 1; col <= width; col++) {
      cells.push(row.getCell(col).text ?? '');
    }
    if (cells.some(cell => cell.trim() !== '')) {
      rows.push(cells);
    }
  });
  return rows;
};

export const readXlsxRows = async (file: File): Promise<string[][]> => {
  const { default: ExcelJS } = await import('exceljs/dist/exceljs.min.js');
  const workbook = new ExcelJS.Workbook();
  await workbook.xlsx.load(await file.arrayBuffer());
  const sheet = pickSheet(workbook);
  if (!sheet) {
    throw new Error('The Excel file has no sheets.');
  }
  return sheetToRows(sheet);
};
